import { useState, useEffect } from "react";
import { Remarkable } from 'remarkable';
import Link from 'next/link';
import Image from "next/image";

export default function CaseStudiesSection({ blogs, catalog, subtitle }) {

  const blogsortByDateCreated = blogs.sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });
  const blogFiltered = blogsortByDateCreated.filter((data) => {
    return data.services?.some(service => service.toLowerCase().includes('ckan'));
  });
  const [blogsFetched, setBlogsFetched] = useState(blogFiltered.slice(0, 1));


  return (
    <div className="mt-8 mb-8  font-['Inter'] px-8 mx-auto xl:max-w-7xl lg:max-w-5xl md:max-w-3xl w-full" tabIndex={0}>
      <h3 className="w-full medium-title text-center font-['Inter']">
        Case Studies
      </h3>
      <div className='group grid grid-rows-8 grid-cols-1 lg:grid-rows-1 lg:grid-cols-12 w-full mt-14 lg:max-h-[679px]
      '>

        <div className=' row-start-1 row-end-5 col-span-full lg:row-span-full lg:col-start-1 lg:col-end-10 w-full  h-fit '>
          <Link href={`../../${blogsFetched[0].urlPath}`}>
            <Image width={640} height={360} src={blogsFetched[0].image} alt='case section' className=' object-cover w-full' />
          </Link>
        </div>

        <div className=' mx-auto w-[95%] mb-8 row-start-4 row-span-4  col-span-full  lg:row-span-full lg:col-start-6 lg:col-span-12 lg:pl-16 sm:pl-10 px-4 pt-4 md:pt-10 lg:w-full lg:h-[85%] lg:mt-[14.4%] bg-white'>
          <div className='flex items-center gap-x-4 mb-3'>
            <h3 className='text-orange-400 font-semibold md:font-bold'>{subtitle}</h3>
            <span className='text-xs rounded-lg bg-gray-50 px-3 py-1.5 font-medium text-gray-500'>
              {blogsFetched[0]?.readingTime ? blogsFetched[0].readingTime + " min read" : "0 min read"}
            </span>
          </div>
          <h3 className="medium-title group-hover:underline">
            <Link href={`../../${blogsFetched[0].urlPath}`}>
              {blogsFetched[0].title}
            </Link>
          </h3>
          <div className="mt-4">
            <p className="text-secgray caret-transparent cursor-default text-sm md:text-lg descp line-clamp-4" dangerouslySetInnerHTML={{ __html: blogsFetched[0].description || blogsFetched[0].brief }}></p>
          </div>
          <div className='no-underline btn-secondary xl:mt-12 mt-6'>
            <Link href='../../showcase/case-studies'>
              See more case studies
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
